module.exports = {
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem1_.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem2_.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem3_.png").default
        },
        {
            "time": 300,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem4_.png").default
        },
        {
            "time": 400,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem5_.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem6_.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem7_.png").default,
            "duration": 50,
        },
        {
            "time": 650,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem8_.png").default
        },
        {
            "time": 750,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem9_.png").default
        },
        {
            "time": 850,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem10_.png").default
        },
        {
            "time": 950,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem11_.png").default
        },
        {
            "time": 1050,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-launch-bomb enem/p-launch-bomb enem12_.png").default
        },
        {
            "time": 1150,
            "image": require("@frog/source/assets/images/bomber-tactics/units/enemy/p-ready-bomb enem/p-ready-bomb enem1_.png").default
        }
    ]
}
